import React, { useEffect } from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

export const FillerIdentityWidget = (props) => {
  const {
    id,
    value,
    onChange,
    options,
    required,
    rawErrors = [],
    schema,
    formContext,
    uiOptions,
  } = props;

  const isFillingForSomeoneElse =
    formContext?.formData?.formSubmissionDetails?.isFillingForSomeoneElse;

  const disabled = isFillingForSomeoneElse !== "Yes";

  useEffect(() => {
    if (disabled) {
      onChange(undefined); // Clear field if disabled
    }
  }, [disabled]);

  return (
    <FormControl
      fullWidth
      required={required}
      error={rawErrors.length > 0}
      disabled={disabled}
    >
      <InputLabel id={`${id}-label`}>{schema.title}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        value={value || ""}
        label={schema.title}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value="">Select an option</MenuItem>
        {options.enumOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
